"use client";

import { OUR_PRODUCTS_DATA } from '@/features/LandingControl/ui/OurProducts/constants';
import { Contact } from '@/widgets/Contact';
import { ProductHeader } from '@/widgets/ProductHeader';
import { WhatGet } from '../../ui/WhatGet';
import { HowWork } from '../../ui/HowWork';
import { WhereUsed } from '../../ui/WhereUsed';
import { Benefits } from '../../ui/Benefits';
import { Offer } from '../../ui/Offer';
import { Price } from '../../ui/Price';

const data = OUR_PRODUCTS_DATA[2];

export const AiAgentContent = () => {
  return (
    <>
      <ProductHeader data={data} side="left" flatTitle  customUrl="#plan" target="_self"/>
      <WhatGet />
      <HowWork />
      <WhereUsed />
      <Benefits />
      <Offer />
      <Price />      
      <Contact storeUrl={data.storeUrl} customUrl="#plan" target="_self"/>
    </>
  );
};
